import { getBrandingLogoAndName } from '@nile/components';

export const setFavIconName = (name, favIconURL) => {
  const favicon = document.querySelector("link[rel~='icon']");
  if (favicon)
    favicon.href = favIconURL || 'https://assets.superopsalpha.com/image.png';

  document.title = name || 'Loading...';
};

export const setFaviconAndAppTitle = () => {
  getBrandingLogoAndName()
    .then(({ name, favIconURL }) => {
      if (name) {
        setFavIconName(name, favIconURL);
      }
    })
    .catch(() => {});
};
